module.exports = __webpack_public_path__ + "static/media/441991885_2330989557098315_6279850579085763089_n.55dbdd2f.jpg";